<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="career_adver">
			<img src="../../../static/career_banner_01.png" class="block" />
		</div>
		<div class="career">
			<div class="w1200">
				<div class="career_top radius20 bs mab30" v-for="(item,index) in top" :key="index">
					<img :src="item.pic" class="career_top_img" />
					<div class="career_top_text">
						<router-link :to="{ path: '/career_details', query: { id: item.id}}"><i class="f26px">{{item.name}}</i><span class="cl_gray">（已有{{item.done_count}}人完成测评）</span></router-link>
						<div class="f16px cl_dark mat10">{{item.intro}}</div>
						<div class="career_top_text_btm mat10">
							<router-link :to="{ path: '/career_details', query: { id: item.id}}" class="tc f18px cl_white radius20 inline">点击进入</router-link>
						</div>
					</div>
				</div>
				<div class="career_btm radius20 bs">
					<div class="swiper-container career_banner">
					    <div class="swiper-wrapper">
					        <div class="swiper-slide career_banner_list" v-for="(item,index) in btm" :key="index">
										<router-link :to="{ path: '/career_details', query: { id: item.id}}" class="block career_banner_list_a">
											<p class="tc f18px clip">{{item.name}}</p>
											<img :src="item.pic" class="mat30" />
											<div class="f16px cl_dark mat5 career_banner_list_btm">{{item.intro}}</div>
										</router-link>
									</div>
					    </div>
					    <div class="swiper-pagination"></div>
					</div>
				</div>
			</div>
		</div>
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	import '@/assets/js/swiper.min.js'
	import '@/assets/css/swiper.min.css'
	export default {
	  name: 'career',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 0,
				top: [],
				btm: [],
			}
		},
		mounted() {
			this.getTop();
			this.getBtm();
		},
		created() {
			
		},
		methods: {
			getTop () {
				this.$get("/api/assess/get_top_assess_project",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.top = res.data;
				});
			},
			getBtm () {
				this.$get("/api/assess/get_not_top_assess_project",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.btm = res.data;
					setTimeout(() => {
						var mySwiper = new Swiper('.career_banner', {
							initialSlide :0,
							slidesPerView : 4,
							spaceBetween : 30,
							pagination: {
								el: '.swiper-pagination',
								clickable :true,
							},
							observer:true,
							observeParents:true,
						});
					}, 1);
					
				});
			},
		},
	}
</script>

<style>
</style>
